var heading_default = {
  "fontElementMap": "-NmKI",
  "elementSpacing": "hXVJd",
  "headerOne": "hLPjc hXVJd",
  "headerTwo": "IWecr hXVJd",
  "headerThree": "EDKJ- hXVJd",
  "headerFour": "lSRLP hXVJd",
  "headerFive": "v4CGG hXVJd",
  "headerSix": "L9VMg hXVJd",
  "child": "Dy0FX"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
